import { useEffect, useState } from 'react'

export function useQueryParams<T extends Record<string, string>>() {
  const [params, setParams] = useState<URLSearchParams | null>(null)
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    setParams(searchParams)
  }, [])

  return params ? (Object.fromEntries(params) as Partial<T>) : params
}
